<template>
  <div class="starMember" :class="[isMVP ? 'isMVP' : '', `mvp_${year}_${season}`]">
    <img class="posterBg" :src="starMemberBg" />
    <main>
      <section>
        <dl>
          <dt :style="{ visibility: isMVP ? 'visible' : 'hidden' }">
            {{ teamInfo.teamName || "" }}
          </dt>
          <dd>{{ teamInfo.servicePointName || "" }}</dd>
        </dl>
      </section>
      <section class="userInfo">
        <dl>
          <dt :style="{ color: '#FBF497' }" v-if="!isSpring">
            {{ posterData.realName || "张三" }}
          </dt>
          <dt :style="{ color: isMVP ? '#FBF497' : '#ffffff' }" v-if="isSpring">
            {{ posterData.realName || "张三" }}
          </dt>
          <dd v-if="posterData.type == 'top_day_service'" :class="[season == 'autumn' ? 'autumn' : '']">
            <img src="../../../../assets/images/winterGame/poster/mvpStudent_jb.png"/>
            {{ posterData.cupNumber | formatNumberFilter }}
          </dd>
          <dd v-else  :class="['challenge_info_wrap', `item_bg_${year}_${season}`]">
            <div class="challenge_info_ul">
              <div class="challenge_info_item">
                <p class="challenge_cup_num">{{ posterData.rc_cnt | formatNumberFilter}}</p>
                <p class="challenge_cup_text">闯关成功次数</p>
              </div>
              <div class="challenge_info_item">
                <p class="challenge_cup_num">{{ posterData.cupNumber | formatNumberFilter}}</p>
                <p class="challenge_cup_text">闯关奖杯数</p>
              </div>
            </div>
          </dd>
        </dl>
        <ul>
          <li v-if="isMVP">
            <p v-if="posterData.type === 'top_day_service'">战队单日奖杯数最多</p>
            <p v-else>服务中心单日闯关成功次数最多<br>且奖杯数最多</p>
          </li>
          <li v-else>
            <p v-if="posterData.type === 'top_day_service'">服务中心单日奖杯数最多</p>
            <p v-else>服务中心单日闯关成功次数最多<br>且奖杯数最多</p>
          </li>
          <li>
            {{ timeFormatFilter(posterData.date) }}
          </li>
        </ul>
        <img
          class="committeeSeal"
          :class="[this.season + '_' + this.year, posterData.type === 'top_day_service' ? '' : 'challenge_committee_seal']"
          src="../../../../assets/images/winterGame/poster/committeeSeal.png"
        />
      </section>
      <ul class="question_ul" :class="[posterData.type === 'top_day_service' ? '' : 'challenge_question']">
        <li>
          <div class="question_item">
            <div class="item_bg">{{ posterData.pk_dur | formatNumberFilter }}</div>
          </div>
          <p class="mvp_item_desc">PK时长(分钟)</p>
        </li>
        <li>
          <div class="question_item">
            <div class="item_bg">{{ posterData.ques_num | formatNumberFilter }}</div>
            <p class="mvp_item_desc">做题数(题)</p>
          </div>
        </li>
        <li v-if="posterData.video_length >= 5">
          <div class="question_item">
            <div class="item_bg">{{ posterData.video_length | formatNumberFilter }}</div>
            <p class="mvp_item_desc">视频时长(分钟)</p>
          </div>
        </li>
      </ul>
      <footer></footer>
    </main>
  </div>
</template>

<script>
import starMemberBg1 from "@images/winterGame/poster/starMemberBg1.png";
import starMemberBg2 from "@images/winterGame/poster/starMemberBg2.png";
import { timeFormatFilter, judgeTempSeason } from "@/util/util.js";

export default {
  name: "newstarMember",
  data() {
    return {
      isSpring: false,
      year: "",
      season: "",
      star_type: "service",
      starMemberBg: null,
      currentSeason: "",
    };
  },
  props: {
    homePosterConfig: {
      type: Object,
      default: () => ({}),
    },
    posterData: {
      type: Object,
      default: function () {
        return {
          realName: "",
          date: "",
          cupNumber: 0,
          pk_dur: 0,
          video_length: 0,
          ques_num: 0,
          type: '',
          rc_cnt: 0,
          score: 0,
        };
      },
    },
    teamInfo: {
      type: Object,
      default: null,
    },
    isMVP: {
      type: Boolean,
      default: false,
    },
    // 2024冬季赛背景判断
    officialPoster:{
      type: Boolean,
      default: false,
    }
  },
  methods: {
    timeFormatFilter(date) {
      return timeFormatFilter(date);
    },
    initSeasonInfo() {
      // 初始化基础季节信息
      [this.isSpring, this.year, this.season] = judgeTempSeason();
      
      // 从路由参数获取季节信息
      if (this.$route.query.seasonId) {
        const { seasonId } = this.$route.query;
        this.updateSeasonFromRoute(seasonId);
      }
    },

    updateSeasonFromRoute(seasonId) {
      // 更新季节信息
      const seasonMap = {
        'chunji': { isSpring: true, season: 'spring' },
        'xiaji': { isSpring: false, season: 'summer' },
        'qiuji': { isSpring: false, season: 'autumn' },
        'winter': { isSpring: false, season: 'winter' }
      };

      // 从 seasonId 中提取年份
      const yearMatch = seasonId.match(/s\.(\d{2})/);
      if (yearMatch) {
        this.year = `20${yearMatch[1]}`;
      }

      // 更新季节
      for (const [key, value] of Object.entries(seasonMap)) {
        if (seasonId.includes(key)) {
          this.isSpring = value.isSpring;
          this.season = value.season;
          break;
        }
      }
    },

    setStarMemberBg() {
      console.log('this.homePosterConfig', this.homePosterConfig)
      const imageMap = {
        mvp: 'star_person_team',
        top_day_service: 'star_person_service',
        default: 'challenge_warriors_bg'
      };

      // const imageType = this.isMVP 
      //   ? imageMap.mvp 
      //   : (this.posterData.type === 'top_day_service' ? imageMap.top_day_service : imageMap.default);

      // this.starMemberBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/${imageType}.png`);
      if (this.posterData.type === 'top_day_service') {
        this.starMemberBg = this.homePosterConfig.mvpStudentPoster;
      } else {
        this.starMemberBg = this.homePosterConfig.challengeWarriorPoster;
      }
    }
  },
  mounted() {
    this.initSeasonInfo();
    this.setStarMemberBg();
  },
};
</script>

<style lang="less" scoped>
.starMember {
  display: flex;
  flex-direction: column;
  > img {
    width: 100%;
  }
  main {
    position: absolute;
    top: 442px;
    left: 0;
    right: 0;
  }

  section {
    position: relative;
    margin-top: 30px;
    &:first-child {
      dl {
        text-align: center;
        dt {
          height: 66px;
          font-size: 48px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 66px;
          margin-bottom: 16px;
        }
        dd {
          margin-left: 0;
          height: 44px;
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 44px;
        }
      }
    }
    &.userInfo {
      position: relative;
      display: flex;
      flex-direction: column;
      height: 402px;
      dl {
        margin-top: 2px;
        text-align: center;
        dt {
          height: 112px;
          font-size: 80px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #fbf497;
          line-height: 112px;
        }
        dd {
          margin: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 64px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          img {
            width: 70px;
            height: 76px;
            margin-right: 10px;
          }
          &.autumn {
            margin: 30px 0 0 0;
          }
          &.challenge_info_wrap {
            width: 626px;
            height: 200px;
            margin: 30px auto 0;
            background: url('../../../../assets/images/winterGame/poster/challenge_warriors_bg.png') no-repeat center center;
            background-size: 100% 100%;
            .challenge_info_ul {
              width: 100%;
              height: 160px;
              display: flex;
              justify-content: space-around;
              .challenge_info_item {
                display: flex;
                flex-direction: column;
                align-items: center;
                .challenge_cup_num {
                  margin: 0;
                  padding: 0;
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 600;
                  font-size: 56px;
                  color: #FFFFFF;
                  line-height: 80px;
                  font-style: normal;
                }
                .challenge_cup_text {
                  margin: 0;
                  padding: 0;
                  font-family: SourceHanSansCN, SourceHanSansCN;
                  font-weight: 400;
                  font-size: 28px;
                  color: #FFFFFF;
                  line-height: 42px;
                  font-style: normal;
                }
              }
            }
          }
          &.item_bg_2025_summer {
            background: url('../../../../assets/images/winterGame/2025/summer/challenge_warriors_bg.png') no-repeat center center!important;
            background-size: 100% 100%!important;
          }
          &.item_bg_2025_spring {
            background: url('../../../../assets/images/winterGame/2025/spring/challenge_warriors_bg.png') no-repeat center center!important;
            background-size: 100% 100%!important;
          }
          &.item_bg_2025_winter {
            background: url('../../../../assets/images/winterGame/2025/winter/challenge_warriors_bg.png') no-repeat center center!important;
            background-size: 100% 100%!important;
          }
        }
      }
      ul {
        margin-top: 10px;
        text-align: center;
        li {
          min-height: 44px;
          font-size: 32px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 44px;
          margin-bottom: 8px;
          p {
            margin: 0;
          }
        }
      }
      img.committeeSeal {
        position: absolute;
        bottom: -440px;
        right: 80px;
        width: 209px;
        float: left;
        &.challenge_committee_seal {
          bottom: -560px;
        }
      }
      .summer_2023 {
        top: 380px !important;
        right: 60px !important;
      }
    }
  }
  .question_ul {
    display: flex;
    justify-content: space-around;
    li {
      .question_item {
        .item_bg {
          width: 220px;
          height: 104px;
          background: url('../../../../assets/images/winterGame/poster/mvpStudent_item_bg.png') no-repeat center center;
          background-size: 100% 100%;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 56px;
          color: #FFFFFF;
          line-height: 80px;
          text-align: right;
          font-style: normal;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .mvp_item_desc {
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 28px;
        color: #FFFFFF;
        line-height: 42px;
        text-align: right;
        font-style: normal;
        text-align: center;
      }
    }
    &.challenge_question {
      margin-top: 150px;
    }
  }
  // footer {
  // }
  &.mvp_2025_winter {
    background: red;
    .question_ul {
      li {
        .question_item {
          .item_bg {
            background: url('../../../../assets/images/winterGame/2025/winter/mvpStudent_item_bg.png') no-repeat center center!important;
            background-size: 100% 100%!important;
          }
        }
      }
    }
  }
  &.mvp_2025_summer {
    .question_ul {
      li {
        .question_item {
          .item_bg {
            background: url('../../../../assets/images/winterGame/2025/summer/mvpStudent_item_bg.png') no-repeat center center!important;
            background-size: 100% 100%!important;
          }
        }
      }
    }
  }
}
</style>
